/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Accept_All_LabelInputs */

const en_spellcheck_accept_all_label = /** @type {(inputs: Spellcheck_Accept_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept all corrections`)
};

const fr_spellcheck_accept_all_label = /** @type {(inputs: Spellcheck_Accept_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter toutes les corrections`)
};

const de_spellcheck_accept_all_label = /** @type {(inputs: Spellcheck_Accept_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Korrekturen akzeptieren`)
};

const it_spellcheck_accept_all_label = /** @type {(inputs: Spellcheck_Accept_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accetta tutte le correzioni`)
};

const ru_spellcheck_accept_all_label = /** @type {(inputs: Spellcheck_Accept_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принять все исправления`)
};

const es_spellcheck_accept_all_label = /** @type {(inputs: Spellcheck_Accept_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar todas las correcciones`)
};

const zh_cn2_spellcheck_accept_all_label = /** @type {(inputs: Spellcheck_Accept_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接受所有更正。`)
};

const ja_spellcheck_accept_all_label = /** @type {(inputs: Spellcheck_Accept_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての修正を受け入れる`)
};

const hi_spellcheck_accept_all_label = /** @type {(inputs: Spellcheck_Accept_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी सुधार स्वीकार करें`)
};

const pt_pt2_spellcheck_accept_all_label = /** @type {(inputs: Spellcheck_Accept_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceitar todas as correções`)
};

/**
* | output |
* | --- |
* | "Accept all corrections" |
*
* @param {Spellcheck_Accept_All_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_accept_all_label = /** @type {((inputs?: Spellcheck_Accept_All_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Accept_All_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_accept_all_label(inputs)
	if (locale === "de") return de_spellcheck_accept_all_label(inputs)
	if (locale === "it") return it_spellcheck_accept_all_label(inputs)
	if (locale === "ru") return ru_spellcheck_accept_all_label(inputs)
	if (locale === "es") return es_spellcheck_accept_all_label(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_accept_all_label(inputs)
	if (locale === "ja") return ja_spellcheck_accept_all_label(inputs)
	if (locale === "hi") return hi_spellcheck_accept_all_label(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_accept_all_label(inputs)
	return en_spellcheck_accept_all_label(inputs)
});